/* eslint-disable max-len */
import React from "react";
import EmptyScreen from "../../../../CommonComponent/ListingScreens/EmptyScreen"
import NoSearchScreen from "../../../../CommonComponent/ListingScreens/NoSearchScreen"
import TableHeader from "../../../../CommonComponent/ListingScreens/TableHeader"
import BidsShimmer from "../bids/bidsShimmer";
import ListingRow from "./ListingRow";

export default function ListingBody({currentSortColumn, handleSort, searchParam, bids, searchValue, loadBids,
    auctionData, loading, deleteBidHandler}){

    const columns = [
        { label: "Lot no.", sortKey: "lot_number", testId: "lot_no", minWidth: "120px" },
        { label: "", minWidth: "120px" },
        { label: "Lot Title", sortKey: "lot_title", testId: "title", minWidth: "120px" },
        { label: "Reserve", sortKey: "reserve", testId: "reserve", minWidth: "120px" },
        { label: "Bidder name", sortKey: "name", testId: "bidder_name", minWidth: "170px" },
        { label: "Paddle no.", sortKey: "paddle_number", testId: "paddle_number", minWidth: "130px" },
        { label: "Phone number", sortKey: "phone_number", testId: "phone_number", minWidth: "170px" },
        { label: "Bid", sortKey: "bid_amount", testId: "bid", minWidth: "120px" },
        { label: "", minWidth: "60px" }
    ];

    return(
        <div className="md:pb-[70px] pb-[100px] pt-2 overflow-auto mt-4 customScrollbar">
            <div className="z-10 border-[#DEDEDE] border rounded-lg xl:w-full w-fit"
                style={{ transform: 'rotateX(180deg)' }} >
                <table aria-label="Outside Table" className="w-full overflow-auto table-auto" 
                    style={{transform: "rotateX(-180deg)"}} >
                    <TableHeader currentSortColumn={currentSortColumn} handleSort={handleSort} columns={columns} />
                    <tbody>
                        {(bids?.length > 0 && !loadBids && !loading) && (
                            bids.map((bid, index)=><ListingRow key={index}
                                bid={bid} auctionData={auctionData}
                                deleteBidHandler={deleteBidHandler}
                            />)
                        )}
                        {(searchParam.get('search_term')!== null && searchValue !== '' && bids?.length===0 && !loadBids ) && 
                            <NoSearchScreen searchValue={searchValue} cols={8} />
                        }
                        {(searchParam.get('search_term')=== null && searchValue === '' && !loadBids && bids?.length===0 && !loading) && 
                            <EmptyScreen message="No bids found" cols={8} />
                        } 
                        {(loadBids || loading) && <BidsShimmer/> }
                    </tbody>
                </table>
                        
            </div>
        </div>
    )
}